module.exports = __webpack_public_path__ + "img/doors.64894ff9.svg";